<template>
  <div class="list-wrap">
    <span class="tc title w100">玉昆钢铁订单管理系统</span>
    <Detail @close="showDialog = false" @refresh="start" v-show="showDialog" :data="detail"></Detail>
    <div v-show="showDel" class="del-wrap fixed">
      <div class="inner">
        <span>提示</span>
        <span class="tc w100">确定删除该条数据吗？请谨慎操作</span>
        <div>
          <span class="btn" @click="toDel">确定</span>
          <span class="btn" @click="cancel">取消</span>
        </div>
      </div>
    </div>
    <div class="option">
      <input type="text" v-model.trim="value" placeholder="请输入姓名">
      <span class="btn" @click="search(value)">搜索</span>
      <span class="option-item ml40">库存：{{getRest}}t</span>
      <span class="option-item ml40">总交易额：{{getTotal}}</span>
      <span class="ml40 btn" @click="addItem">新增交易</span>
    </div>
    <ListItem :isHead="true" :data="headOption"></ListItem>
    <ListItem 
      :class="index == 0 && item.name == totalList[0].name ? 'in' : 'out'"
      v-for="(item, index) in list" 
      :key="index" 
      :data="item" 
      :home="true"
      @onClick="clickItem($event, index)">
    </ListItem>
  </div>
</template>

<script>
import ListItem from '@/components/ListItem.vue';
import Detail from '@/components/Detail.vue';
import { getStorage, setStorage } from '@/utils/index';

export default {
  name: 'List',
  components: {
    ListItem,
    Detail
  },
  data: function () {
    return {
      showDialog: false,
      showDel: false,
      currentDelItem: {},
      detail: {
      },
      value: '',
      headOption: {
        name: '姓名',   // 姓名
        address: '地址',    // 地址
        phone: '电话',  // 电话
        order: '预定量',
        sended: '成交量',
        totalPrice: '交易额', // 总价
        rest: '未完成量',
        tip: '备注',
        operate: '操作'
      },
      list: [],
      totalList: []
    }
  },
  mounted() {
    this.start();
  },
  computed: {
    getRest() {
      const list = this.totalList;
      if(list.length <= 0) return 0;

      let total = 0;
      list[0].list && list[0].list.map(item => {
        item.amount && (total += item.amount);
      });

      let used = 0;
      list.slice(1).forEach(item => {
        item.list && item.list.map(ware => {
          ware.amount && (used += ware.amount);
        });
      });

      return (total - used).toFixed(2);
    },
    getTotal() {
      if(this.totalList.length <= 0) return 0;

      let total = 0;
      this.totalList.slice(1).forEach(item => {
        item.list.map(ware => {
          ware.amount && ware.singlePrice && (total += (ware.amount * ware.singlePrice));
        });
      });

      return total.toFixed(2);
    }
  },
  methods: {
    start() {
      getStorage().then(res => {
        this.list = res;
        this.totalList = res;
      });
    },
    clickItem(type, index) {
      this.currentDelItem = this.list[index];
      if(type == 'edit') {
        this.detail = this.list[index];
        this.showDialog = true;
      } else {
        this.showDel = true;
      }
    },
    search(val) {
      getStorage().then(res => {
        if(!val) {
          this.list = res;
          return;
        }
        this.list = res.filter((item, index) => {
          return item.name && item.name.match(val);
        });
      })
    },
    addItem() {
      this.detail = {};
      this.showDialog = true;
    },
    cancel() {
      this.showDel = false;
    },
    toDel() {
      this.list = this.list.filter(item => {
        return item != this.currentDelItem;
      });
      setStorage(this.list);
      this.start();
      this.cancel();
    }
  }
}
</script>

<style>
.tc {
  text-align: center;
}
.title{
  height: 60px;
  line-height: 60px;
  letter-spacing: 5px;
}
.option {
  width: 100%;
  display: flex;
  align-items: center;
  height: 60px;
}
.ml40 {
  margin-left: 40px;
}
input {
  height: 32px;
  padding: 0 10px;
  border: 1px solid #eee;
  margin: 0 30px;
}
.w100 {
  width: 100%;
}
.list-wrap {
  width: 100%;
}
.btn {
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  color: #fff;
  padding: 0 10px;
  background: #51a9dc;
  border-radius: 5px;
}
.fixed {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background: rgba(0, 0, 0, .5);
}
.del-wrap .inner {
  width: 300px;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 20px;
}
.del-wrap .inner .btn {
  margin-top: 50px;
  width: 71px;
  text-align: center;
}
.del-wrap .inner .tc {
  margin-top: 30px;
}
.del-wrap .inner div {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0 15px;
  align-items: center;
  justify-content: space-between;
}
.in {
  background: #63cc6b;
}
</style>